var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_3_Fast_delivery"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m332.375 370.604h-257.575c-5.523 0-10-4.477-10-10v-42.391h267.575z",
    fill: "#3b4754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.8 355.44v6.221c0 4.939 4.004 8.943 8.943 8.943h258.632v-15.164z",
    fill: "#2a333c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.678 370.604h-165.303v-246.295h101.54c6.501 0 12.489 3.527 15.642 9.212l40.234 72.556c11.038 19.906 16.83 42.293 16.83 65.054v90.53c0 4.939-4.004 8.943-8.943 8.943z",
    fill: "#83b0d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.791 206.076-40.234-72.556c-2.876-5.186-8.114-8.566-13.945-9.122l36.884 66.514c11.038 19.906 16.83 42.293 16.83 65.054v90.53c0 4.939-4.004 8.943-8.943 8.943h-148.008v15.164h165.303c4.939 0 8.943-4.004 8.943-8.943v-90.53c0-22.761-5.792-45.148-16.83-65.054z",
    fill: "#649dce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.375 318.212h-267.575v-219.207c0-5.523 4.477-10 10-10h247.575c5.523 0 10 4.477 10 10z",
    fill: "#718aad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.432 89.005h-19.637c4.939 0 8.943 4.004 8.943 8.943v220.264h19.637v-220.264c0-4.939-4.004-8.943-8.943-8.943z",
    fill: "#577399"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.767,
    cy: 370.604,
    fill: "#5d7083",
    r: 52.391
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.665 329.054c6.793 8.836 10.842 19.891 10.842 31.898 0 28.935-23.457 52.391-52.392 52.391-12.007 0-23.063-4.048-31.898-10.842 9.578 12.457 24.622 20.493 41.55 20.493 28.935 0 52.392-23.457 52.392-52.391-.001-16.928-8.037-31.971-20.494-41.549z",
    fill: "#495867"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.767,
    cy: 370.604,
    fill: "#e0ebf5",
    r: 15.621
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.196,
    cy: 370.604,
    fill: "#5d7083",
    r: 52.391
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.094 329.054c6.793 8.836 10.842 19.891 10.842 31.898 0 28.935-23.457 52.391-52.391 52.391-12.007 0-23.063-4.048-31.898-10.842 9.578 12.457 24.622 20.493 41.55 20.493 28.935 0 52.391-23.457 52.391-52.391 0-16.928-8.037-31.971-20.494-41.549z",
    fill: "#495867"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.196,
    cy: 370.604,
    fill: "#e0ebf5",
    r: 15.621
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.323 282.359h-17.588c-4.939 0-8.943 4.004-8.943 8.943v21.311c0 14.817 12.012 26.829 26.829 26.829v-48.218c0-2.963-.103-5.919-.298-8.865z",
    fill: "#649dce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.326 282.359v50.757c4.671 3.944 10.704 6.325 17.295 6.325v-48.218c0-2.963-.103-5.919-.298-8.865h-16.997z",
    fill: "#4589c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.683 219.725 105.086 24.022c6.904 1.578 12.878-5.136 10.403-11.772-1.93-5.174-4.245-10.21-6.933-15.057l-36.403-65.647c-1.576-2.843-4.571-4.606-7.821-4.606h-62.339c-4.939 0-8.943 4.004-8.943 8.943v55.398c0 4.172 2.883 7.79 6.95 8.719z",
    fill: "#e0ebf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.015 146.666h-62.339c-4.939 0-8.943 4.004-8.943 8.943v55.398c0 3.618 2.171 6.816 5.399 8.208l70.951-70.951c-1.468-1.013-3.222-1.598-5.068-1.598z",
    fill: "#f7f7ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 210.358,
    cy: 202.875,
    fill: "#f7f7ff",
    r: 81.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.68 225.58c-1.48 2.57-4.17 4-6.93 4-1.36 0-2.73-.34-3.99-1.07l-32.4-18.71c-2.39-1.38-4-3.97-4-6.93v-41.66c0-4.41 3.58-8 8-8s8 3.59 8 8v37.05l28.4 16.39c3.82 2.21 5.13 7.1 2.92 10.93z",
    fill: "#718aad"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#e0ebf5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.544 139.941h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.544 193.968h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.544 247.995h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.544 302.021h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3b4754"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.544 128.835h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.544 182.862h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.544 236.888h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.544 290.915h-74.165c-3.866 0-7-3.134-7-7s3.134-7 7-7h74.165c3.866 0 7 3.134 7 7s-3.134 7-7 7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.ad2a3ed03931ee4715dbd0a3463fea22.svg";
export { ForwardRef as ReactComponent };